<template>
  <div ref="preview" class="preview">
    <img v-if="file.image" :src="file.image" :alt="file.original" />
  </div>
</template>

<script>
import $ from 'jQuery';
import plupload from 'plupload';

export default {
  props: {
    uploader: {
      type: Object,
      required: true
    },
    file: {
      type: Object,
      required: true
    },
    maxWidth: {
      type: Number,
      default: 999
    },
    maxHeight: {
      type: Number,
      default: 240
    }
  },
  created() {
    if (!this.file.image) {
      this.loadImagePreview();
    }
  },
  methods: {
    loadImagePreview() {
      const image = $(new window.Image());
      const preloader = new plupload.moxie.image.Image();
      const source = this.uploader.getFile(this.file.id);

      if (!source) {
        return;
      }

      preloader.onload = () => {
        preloader.downsize(this.maxWidth, this.maxHeight);

        const imageDataUrl = preloader.getAsDataURL();
        if (imageDataUrl) {
          image.appendTo(this.$refs.preview);
          image.prop('src', imageDataUrl);
          this.$emit('imageDataUrl', imageDataUrl);
        }
      };

      preloader.load(source.getSource());
    }
  }
};
</script>
